import type { ModelEntitySearchResponse } from '@upright/common/model/search/api-types';
import { compact } from 'lodash';
import { SearchAttempts, SearchEntityType } from '../../../../common/model/search/types';
import { fetchOrThrow } from '../../common/fetchers/fetch-or-throw';
import { fetchApiWithError } from '../../common/fetchers/fetch-with-error';

export async function fetchSearchResults(
  query: string,
  types?: readonly SearchEntityType[],
  onlyPublicEntities?: boolean,
  includeVisibility?: boolean,
) {
  const typesAsString = JSON.stringify(types);
  const typesToQuery = types ? `types=${typesAsString}` : '';
  const onlyPublicEntitiesString = onlyPublicEntities ? `onlyPublicEntities=true` : undefined;
  const includeVisibilityString = includeVisibility ? `includeVisibility=true` : undefined;

  // Would make sense to convert this to JSON.
  const additionalOptions =
    onlyPublicEntities || includeVisibility
      ? `&${compact([onlyPublicEntitiesString, includeVisibilityString]).join('&')}`
      : '';

  return await fetchOrThrow<ModelEntitySearchResponse>(
    `/search/text-search?query=${encodeURIComponent(query)}&${typesToQuery}${additionalOptions}`,
    'GET',
  );
}

// TODO ML: Add types to payload / url
export async function fetchSemanticSearchResults(
  query: string,
  types: readonly SearchEntityType[], // Should be only product, mixin or phenomenon, enforced by the caller
  onlyPublicEntities?: boolean,
  includeVisibility?: boolean,
) {
  const typesToQuery = `types=${JSON.stringify(types)}`;
  const onlyPublicEntitiesString = onlyPublicEntities ? `onlyPublicEntities=true` : undefined;
  const includeVisibilityString = includeVisibility ? `includeVisibility=true` : undefined;

  const additionalOptions =
    onlyPublicEntities || includeVisibility
      ? `&${compact([onlyPublicEntitiesString, includeVisibilityString]).join('&')}`
      : '';

  return await fetchOrThrow<ModelEntitySearchResponse>(
    `/search/semantic-product-search?query=${encodeURIComponent(query)}&${typesToQuery}${additionalOptions}`,
    'GET',
  );
}

export async function sendSearchAttempts(attempts: SearchAttempts) {
  return await fetchApiWithError<undefined>('/search/capture-attempts', 'POST', attempts);
}

export async function rebuildElasticSearchEntityIndex() {
  return await fetchApiWithError<undefined>(`/search/rebuild-elastic-search-entity-index`, 'POST');
}

export async function rebuildSemanticSearchProductIndex() {
  return await fetchApiWithError<undefined>(`/search/rebuild-semantic-product-index-job`, 'POST');
}
